import { TariffKindInternal, TierPrice } from '../../../../../data-access/gql-types/graphql';
import { useDevicesAndChannelsContext } from '../../../context/devices-and-channels';
import { ChannelMeterTypeOrUndefined } from '../../../types';
import { TariffHoursRange } from '../../../types/tariffs';
import { useTariffConfigurationContext } from '../context/tariff-configuration-context';

export type SetPricesData = {
  selectedTariff: TariffKindInternal | null;
  hoursRanges: TariffHoursRange[] | null;
};

export const useMeterTariffPricesConfiguration = () => {
  const { channel } = useDevicesAndChannelsContext();
  const { form } = useTariffConfigurationContext();

  const getPrice = (pricingTier: number, prices?: TierPrice[]) => {
    return prices?.find((x) => x.pricingTier === pricingTier)?.price || 0;
  };

  const generatePriceSlots = (tiers: number[], prices?: TierPrice[]) => {
    form.setValue(
      'prices',
      tiers.map((p) => ({ price: getPrice(p, prices), pricingTier: p })),
    );
  };

  const setDefaultForm = (hoursRanges: TariffHoursRange[], prices?: TierPrice[]) => {
    if (!hoursRanges.length) {
      form.setValue('prices', [{ price: getPrice(2, prices), pricingTier: 2 }]);
    } else {
      if (hoursRanges.find((x) => x.pricingTier === 3)) {
        generatePriceSlots([1, 2, 3], prices);
      } else {
        generatePriceSlots([1, 2], prices);
      }
    }
  };

  const handleSetPrices = ({ selectedTariff, hoursRanges }: SetPricesData) => {
    if (
      !selectedTariff ||
      !hoursRanges ||
      selectedTariff.includes('_DYNAMIC') ||
      selectedTariff === TariffKindInternal.TauronG13S
    ) {
      form.setValue('prices', []);
      return;
    }

    const tariffConfigurations = (channel?.data as ChannelMeterTypeOrUndefined)?.sharedChannelSettings
      ?.tariffConfigurations;

    if (tariffConfigurations?.length) {
      const savedData = tariffConfigurations.find((x) => x.tariff === selectedTariff);

      if (savedData) {
        setDefaultForm(hoursRanges, savedData.prices);
      } else setDefaultForm(hoursRanges);
    } else setDefaultForm(hoursRanges);
  };

  return {
    handleSetPrices,
  };
};
